import React from 'react';
import { IconProps } from '.';

const SvgBoxJapan = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#fff'
        d='M2 5.333A3.333 3.333 0 0 1 5.333 2h13.334A3.333 3.333 0 0 1 22 5.333v13.334A3.333 3.333 0 0 1 18.667 22H5.333A3.333 3.333 0 0 1 2 18.667V5.333Z'
      />
      <path
        fill='#E0E0E4'
        fillRule='evenodd'
        d='M18.667 3.25H5.333c-1.15 0-2.083.933-2.083 2.083v13.334c0 1.15.933 2.083 2.083 2.083h13.334c1.15 0 2.083-.933 2.083-2.083V5.333c0-1.15-.933-2.083-2.083-2.083ZM5.333 2A3.333 3.333 0 0 0 2 5.333v13.334A3.333 3.333 0 0 0 5.333 22h13.334A3.333 3.333 0 0 0 22 18.667V5.333A3.333 3.333 0 0 0 18.667 2H5.333Z'
        clipRule='evenodd'
      />
      <path fill='#BC002D' d='M17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z' />
    </svg>
  );
};

export default SvgBoxJapan;
